export default import.meta.ROLLUP_FILE_URL_C9oa6XCK;